import { FileSearch, Gauge, ShieldCheck, Workflow } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@insightai/ui'

/** M00-05 — four USP cards. */
const USPS = [
  {
    Icon: Workflow,
    title: 'Structured before it is answered',
    body: 'TOSCA framing and a MECE issue tree turn a vague business question into a research design, so you find out what you actually need to know.',
  },
  {
    Icon: FileSearch,
    title: 'Provenance on every claim',
    body: 'Each synthesised statement carries its source, publication and retrieval dates, the supporting passage and a credibility band. Contradictions are surfaced, not smoothed over.',
  },
  {
    Icon: Gauge,
    title: 'Costs as ranges, up front',
    body: 'A dynamic min–max estimate with a breakdown before you commit — never a single number that quietly becomes a floor.',
  },
  {
    Icon: ShieldCheck,
    title: 'Research-ops oversight built in',
    body: 'A Research Lead reviews and approves. AI recommendations are always explained and always overridable, and every override is logged with its reason.',
  },
]

export function UspCards() {
  return (
    <section aria-labelledby="usp-heading" className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
      <h2 id="usp-heading" className="text-h1">
        Why teams choose InsightAI
      </h2>
      <p className="max-w-2xl pt-2 text-body text-text-secondary">
        Speed is the easy part. What makes AI research usable is being able to show where every
        number came from.
      </p>

      <ul className="grid gap-4 pt-8 sm:grid-cols-2 lg:grid-cols-4">
        {USPS.map(({ Icon, title, body }) => (
          <li key={title}>
            <Card className="h-full" interactive>
              <CardHeader>
                <span
                  aria-hidden
                  className="flex size-9 items-center justify-center rounded-md bg-surface-selected text-brand-primary"
                >
                  <Icon className="size-4" />
                </span>
                <CardTitle className="pt-2 text-body">{title}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription>{body}</CardDescription>
              </CardContent>
            </Card>
          </li>
        ))}
      </ul>
    </section>
  )
}
